// @flow

import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const DEBUG = false;

type FaqListProps = {
	classClosed: string,
};

const fragments = {
	ITEM_ITEM:    '[data-fragment="FaqList.item"]',
	ITEM_TOGGLER: '[data-fragment="FaqList.toggler"]',
	ITEM_BODY:    '[data-fragment="FaqList.body"]',
};

/**
 * Komponenta pro obsluhu FAQ seznamu
 */
class FaqList extends WebComponent {

	defaultProps: FaqListProps;
	props: FaqListProps;
	objects: Object;
	element: HTMLElement;
	allowOpenAll: boolean;

	static defaultProps = {
		allowOpenAll: false,
		classClosed:  'closed',
	};

	constructor(props) {
		super(props);
		this.clickHeaderHandler = this.clickHeaderHandler.bind(this);
		this.objects = {};
		clog(`constructed`, this);
	}

	didMount() {
		// clog(`mounted`);
		const isBadBrowser = /Trident/i.test(navigator.userAgent);

		this.mapObjects();

		if ( !isBadBrowser ) {
			this.bindListeners();
			if ( this.objects.items ) {
				this.closeItems(this.objects.items);
			}
			if ( window.location.hash ) {
				const linkedItem = document.querySelector(window.location.hash);
				this.showItem(linkedItem);
			}
		}
		if ( isBadBrowser ) {
			this.hideTogglerIcon();
		}
	}

	willUnMount() {
		// clog(`unmounting`);
		this.objects = {};
	}

	mapObjects() {
		// clog(`mapping`, this);
		this.objects = {};
		this.objects.items = this.element.querySelectorAll(fragments.ITEM_ITEM);
		this.objects.togglers = this.element.querySelectorAll(fragments.ITEM_TOGGLER);
	}

	bindListeners() {
		// clog(`binding`);
		if ( this.objects.togglers ) {
			this.on('click', fragments.ITEM_TOGGLER, this.clickHeaderHandler);
			this.on('touch', fragments.ITEM_TOGGLER, this.clickHeaderHandler);
		}
	}

	clickHeaderHandler(event: ?SyntheticEvent<MouseEvent | TouchEvent>) {
		// clog(`faq header clicked`);
		event.preventDefault();
		const selectedItem = event.currentTarget.parentNode;

		if ( !this.props.allowOpenAll ) {
			this.closeItems(this.objects.items);
		}
		this.toggleItem(selectedItem);
	}

	closeItems(items: NodeList<HTMLDivElement>) {
		// clog(`closing`);
		[ ...items ].forEach((item) => {
			item.classList.add(this.props.classClosed);
		});
	}

	showItem(item: HTMLDivElement) {
		// clog(`opening`);
		item.dataset.opened = 'true';
		item.classList.remove(this.props.classClosed);
	}

	toggleItem(item: HTMLDivElement) {
		// clog(`toggling`);
		if ( item.dataset.opened === 'true' ) {
			item.dataset.opened = 'false';
			this.closeItems([ ...item ]);
		} else {
			item.dataset.opened = 'true';
			this.showItem(item);
		}
	}

	hideTogglerIcon() {
		[ ...this.objects.togglers ].forEach((toggler) => {
			const icon = toggler.querySelector('.glyphicon');
			icon.parentNode.removeChild(icon);
		});
	}
}

// simple logger
function clog(...args: any): void {
	if ( window.console && DEBUG ) {
		/* eslint-disable no-alert, no-console */
		console.group('Debug of FaqList');
		Object.values(args).forEach(value => console.log(value));
		console.groupEnd();
		/* eslint-enable no-alert, no-console */
	}
}

export default FaqList;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FaqList.js